module.exports = __webpack_public_path__ + "img/brand-beams.107c4f18.svg";